"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrestigesPerfectPieceAbilityHandler = exports.PrestigesPerfectPieceActorAbilityFactory = exports.PrestigesPerfectPieceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const Duration_1 = require("../../core/Duration");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_3 = require("../../core/event-handlers/core");
class PrestigesPerfectPieceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.PrestigesPerfectPiece;
        this.__typeName = "PrestigesPerfectPiece";
    }
}
exports.PrestigesPerfectPieceAbilityArgs = PrestigesPerfectPieceAbilityArgs;
let PrestigesPerfectPieceActorAbilityFactory = class PrestigesPerfectPieceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("PrestigesPerfectPiece", "AllAllies", 4);
    }
};
PrestigesPerfectPieceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("PrestigesPerfectPiece")
], PrestigesPerfectPieceActorAbilityFactory);
exports.PrestigesPerfectPieceActorAbilityFactory = PrestigesPerfectPieceActorAbilityFactory;
let PrestigesPerfectPieceAbilityHandler = class PrestigesPerfectPieceAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            animatedId: ability.invokerId,
            fallback: "casting",
            onAnimated: sequence => {
                const buffIds = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies)
                    .map(targetId => container.applyBuff({
                    sequence,
                    creatorId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Permanent,
                    effect: new core_1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.CriticalStrikeChance, 100),
                    onApplied: sequence => sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "chest", "front"), 
                    // TODO: use a better vfx
                    "BlueHealingWinds"))
                }));
                // TODO: link these event handlers?
                container.registerEventHandler(ability.invokerId, EventType_1.EventType.Attack, Schedule_1.Schedule.Once(), new core_3.CancelEffectsEventHandlerArgs(buffIds));
                container.registerEventHandler(ability.invokerId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_3.CancelEffectsEventHandlerArgs(buffIds));
            }
        });
    }
};
PrestigesPerfectPieceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.PrestigesPerfectPiece)
], PrestigesPerfectPieceAbilityHandler);
exports.PrestigesPerfectPieceAbilityHandler = PrestigesPerfectPieceAbilityHandler;
